<template>
      <span v-if="date" class="xl:tw-inline-block badge badge-primary tw-py-1 " >ÉRKEZIK {{ year }}.{{ getFormatedMonth }}.</span>
</template>

<script>
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class MonthBadge extends Vue {

  @Prop(String) date;

  year = null;
  month = null;

  created(){
    let date = new Date(this.date)
    this.year = date.getFullYear()
    this.month = date.getMonth()
  }

  get getFormatedMonth(){

    let arr_of_monthes = [ 'jan', 'febr',  'márc',  'ápr', 'máj', 'jún',  'júl', 'aug',  'szept',  'okt', 'nov',  'dec'];

    return arr_of_monthes[this.month];

  }


}
</script>
